<section class="at-festivals-wrapper">
  <!-- ongoing festivals -->
  <ng-container *ngIf="ongoingFestivals.length > 0">
    <ng-container *ngTemplateOutlet="title; context: { $implicit: 'ongoing', active: true }"></ng-container>
    <ng-container *ngFor="let festival of ongoingFestivals">
      <ush-festival-item [festivalEdition]="festival.festivalEdition"></ush-festival-item>
    </ng-container>
  </ng-container>

  <!-- upcoming festivals -->
  <ng-container *ngIf="upcomingFestivals.length > 0">
    <ng-container *ngTemplateOutlet="title; context: { $implicit: 'upcoming', active: true }"></ng-container>
    <ng-container *ngFor="let festival of upcomingFestivals">
      <ush-festival-item [festivalEdition]="festival.festivalEdition"></ush-festival-item>
    </ng-container>
  </ng-container>
  <!-- highlights -->

  <!-- past festivals -->
  <!-- check out past festivals opener -->
  <ng-container *ngIf="pastFestivals"></ng-container>
  <div
    class="past-festivals-trigger"
    [ngClass]="{ active: pastfilmsActive }"
    (click)="pastfilmsActive = !pastfilmsActive"
  >
    {{ 'title.festivals.checkoutPastFestivals' | translate }}
  </div>
  <div class="past-festivals-wrapper" [ngClass]="{ active: pastfilmsActive }">
    <ng-container
      *ngTemplateOutlet="title; context: { $implicit: 'pastFestivals', active: pastfilmsActive }"
    ></ng-container>
    <div class="festival-cards-container">
      <ng-container *ngFor="let festival of pastFestivals">
        <ush-festival-item [festivalEdition]="festival.festivalEdition"></ush-festival-item>
      </ng-container>
    </div>
  </div>
</section>

<ng-template #title let-title let-active="active">
  <div class="at-festivals-title-wrapper" [ngClass]="{ active: active }">
    <span></span>
    <span class="at-festivals-title">
      {{ 'title.festivals.' + title | translate }}
    </span>
  </div>
</ng-template>
